import { Alert as AlertIcon } from '@arvesta-websites/icons';
import type React from 'react';

import type { FieldType, FormDataTypeOptions } from '../../../../types';
import { withErrorBoundary } from '../../ErrorBoundary';

import { StyledError, StyledFormRowRadio, StyledLabel, StyledRadioSpan } from './Styled';

type InputProps = {
  field: FieldType;
  label: string;
  options: Array<{ name: string; label: string }>;
  handleChange: (e: React.MouseEvent<HTMLInputElement>, name: FormDataTypeOptions, value: string) => void;
};

const RadioFieldGroup = ({ field, label, options, handleChange }: InputProps) => (
  <StyledFormRowRadio className={field.error && 'error'}>
    <StyledLabel>{label}</StyledLabel>
    {options.map(option => (
      <StyledLabel key={option.name}>
        <input
          className="form-radio-button"
          id={option.name}
          name={field.name}
          value={field.name}
          onClick={e => handleChange(e, field.name, option.name)}
          defaultChecked={field.value !== '' ? field.value === field.name : undefined}
        />
        <StyledRadioSpan className={field.value.toLowerCase() === option.name.toLowerCase() ? 'true' : 'false'} />
        {option.label}
      </StyledLabel>
    ))}

    {field.error && (
      <StyledError>
        <AlertIcon />
        <span>{field.error}</span>
      </StyledError>
    )}
  </StyledFormRowRadio>
);

export default withErrorBoundary(RadioFieldGroup, { componentName: 'RadioFieldGroup' });
